export default __webpack_public_path__ + "static/media/inner-360-factory-visibility.024dd5aa.svg";